<div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-xl">
  <div>
    <h1 class="font-headline-lg text-headline-lg text-text-main dark:text-on-surface mb-1">Dealer Management</h1>
    @if (syncMessage()) {
      <p class="text-text-muted dark:text-on-surface-variant font-body-sm text-body-sm">{{ syncMessage() }}</p>
    }
  </div>
  <div class="flex items-center gap-3">
    <button (click)="syncWithHubspot()" [disabled]="syncing()"
            class="h-[48px] px-6 border border-border-subtle dark:border-outline-variant rounded-lg text-text-main dark:text-on-surface hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors flex items-center gap-2 font-label-md disabled:opacity-50">
      <span class="material-symbols-outlined text-[#00B9F2]" [class.animate-spin]="syncing()">sync</span>
      {{ syncing() ? 'Syncing...' : 'HubSpot Sync' }}
    </button>
    <button (click)="openAddModal()" class="h-[48px] px-6 bg-[#00B9F2] text-white rounded-lg hover:opacity-90 transition-opacity flex items-center gap-2 font-label-md">
      <span class="material-symbols-outlined">add_business</span>
      Add Dealer
    </button>
  </div>
</div>

<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-gutter mb-xl">
  <div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-lg flex flex-col relative overflow-hidden group shadow-sm">
    <div class="absolute -right-4 -top-4 w-24 h-24 bg-[#00B9F2]/10 rounded-full blur-xl group-hover:bg-[#00B9F2]/20 transition-all"></div>
    <div class="flex items-start justify-between mb-4">
      <span class="text-text-muted dark:text-on-surface-variant font-label-md">Total Dealers</span>
      <div class="w-8 h-8 rounded-lg bg-blue-50 dark:bg-surface-variant flex items-center justify-center text-[#00B9F2]">
        <span class="material-symbols-outlined text-[20px]">store</span>
      </div>
    </div>
    <div class="flex items-end gap-3 mt-auto">
      <span class="font-headline-lg text-headline-lg text-text-main dark:text-on-surface">{{ overallTotalCount() }}</span>
    </div>
  </div>
</div>

<div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl flex flex-col overflow-hidden shadow-sm">
  <div class="p-md border-b border-border-subtle dark:border-outline-variant flex flex-col sm:flex-row sm:items-center justify-between gap-4">
    <div class="flex flex-wrap items-center gap-3">
      <div class="relative">
        <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-text-muted dark:text-on-surface-variant text-[20px]">search</span>
        <input [value]="searchTerm()" (input)="onSearchInput($any($event.target).value)"
               class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg pl-10 pr-4 py-2 text-body-sm focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] transition-all w-full sm:w-64 h-[48px] text-text-main dark:text-white placeholder:text-text-muted" placeholder="Search dealers..." type="text">
      </div>
      <input [value]="stateFilter()" (change)="onStateFilterChange($any($event.target).value)"
             class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] transition-all w-36 h-[48px] text-text-main dark:text-white placeholder:text-text-muted" placeholder="State" type="text">
      <input [value]="cityFilter()" (change)="onCityFilterChange($any($event.target).value)"
             class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] transition-all w-36 h-[48px] text-text-main dark:text-white placeholder:text-text-muted" placeholder="City" type="text">
      <select [value]="customerStatusFilter()" (change)="onCustomerStatusFilterChange($any($event.target).value)"
              class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] transition-all h-[48px] text-text-main dark:text-white">
        <option value="">All Customer Statuses</option>
        @for (status of customerStatusOptions; track status) {
          <option [value]="status">{{ status }}</option>
        }
      </select>
      <select [value]="productFilter()" (change)="onProductFilterChange($any($event.target).value)"
              class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] transition-all h-[48px] text-text-main dark:text-white">
        <option value="">All Products</option>
        @for (product of productOptions; track product.value) {
          <option [value]="product.value">{{ product.label }}</option>
        }
      </select>
      <select [value]="csatFilter()" (change)="onCsatFilterChange($any($event.target).value)"
              class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] transition-all h-[48px] text-text-main dark:text-white">
        <option value="">All CSAT Levels</option>
        @for (csat of csatOptions; track csat) {
          <option [value]="csat">{{ csat }}</option>
        }
      </select>
      <select [value]="driveOverVersionFilter()" (change)="onDriveOverVersionFilterChange($any($event.target).value)"
              class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] transition-all h-[48px] text-text-main dark:text-white">
        <option value="">All Drive Over Versions</option>
        @for (version of driveOverVersionOptions; track version) {
          <option [value]="version">{{ version }}</option>
        }
      </select>
      <button (click)="clearFilters()" [disabled]="!hasActiveFilters()"
              class="h-[48px] px-4 border border-border-subtle dark:border-outline-variant rounded-lg text-text-main dark:text-on-surface hover:bg-surface dark:hover:bg-surface-variant transition-colors flex items-center gap-2 font-label-md disabled:opacity-40">
        <span class="material-symbols-outlined text-[20px]">filter_alt_off</span>
        Clear Filters
      </button>
    </div>
    <div class="flex items-center gap-3 text-text-muted dark:text-on-surface-variant font-label-sm">
      <span>Page {{ page() }} of {{ totalPages() }} &middot; {{ totalCount() }} dealers</span>
      <div class="flex gap-1">
        <button (click)="goToPreviousPage()" [disabled]="page() <= 1" class="w-8 h-8 rounded hover:bg-surface-variant dark:hover:bg-surface-variant flex items-center justify-center disabled:opacity-50">
          <span class="material-symbols-outlined text-[20px]">chevron_left</span>
        </button>
        <button (click)="goToNextPage()" [disabled]="page() >= totalPages()" class="w-8 h-8 rounded hover:bg-surface-variant dark:hover:bg-surface-variant flex items-center justify-center disabled:opacity-50">
          <span class="material-symbols-outlined text-[20px]">chevron_right</span>
        </button>
      </div>
    </div>
  </div>

  <div class="overflow-x-auto">
    <table class="w-full text-left border-collapse min-w-[1100px]">
      <thead>
        <tr class="bg-surface dark:bg-surface-container border-b border-border-subtle dark:border-outline-variant">
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Dealer</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Address</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Supervisor</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Products</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Lanes</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">CSAT</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Customer Status</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Client Success Manager</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Service Advisor</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium text-right">Actions</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-border-subtle dark:divide-outline-variant">
        @if (loading()) {
          <tr>
            <td colspan="10" class="p-6 text-center text-text-muted dark:text-on-surface-variant font-body-sm">Loading dealers...</td>
          </tr>
        } @else if (error()) {
          <tr>
            <td colspan="10" class="p-6 text-center text-error font-body-sm">{{ error() }}</td>
          </tr>
        } @else if (dealers().length === 0) {
          <tr>
            <td colspan="10" class="p-6 text-center text-text-muted dark:text-on-surface-variant font-body-sm">No dealers found.</td>
          </tr>
        }
        @for (dealer of dealers(); track dealer.hubspotDealerId) {
          <tr class="hover:bg-surface dark:hover:bg-surface-variant/50 transition-colors group">
            <td class="p-4">
              <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant flex items-center justify-center text-[#00B9F2]">
                  <span class="material-symbols-outlined">store</span>
                </div>
                <div>
                  <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">{{ dealer.dealerName }}</p>
                  <p class="text-text-muted dark:text-on-surface-variant text-xs">{{ dealer.email || 'No email' }}</p>
                  <p class="text-text-muted dark:text-on-surface-variant text-xs">HubSpot: {{ dealer.hubspotDealerId }}</p>
                </div>
              </div>
            </td>
            <td class="p-4">
              <p class="font-body-sm text-text-main dark:text-on-surface">{{ dealer.streetName }}</p>
              <p class="text-text-muted dark:text-on-surface-variant text-xs">{{ dealer.city }}, {{ dealer.state }} {{ dealer.zipCode }}</p>
            </td>
            <td class="p-4">
              <p class="font-body-sm text-text-main dark:text-on-surface">{{ dealer.supervisorName || 'N/A' }}</p>
            </td>
            <td class="p-4">
              @if (dealer.driveOver) {
                <p class="text-xs text-text-main dark:text-on-surface">Drive Over: {{ dealer.driveOver }}</p>
              }
              @if (dealer.handheld) {
                <p class="text-xs text-text-main dark:text-on-surface">Handheld: {{ dealer.handheld }}</p>
              }
              @if (dealer.otherProducts) {
                <p class="text-xs text-text-main dark:text-on-surface">Other: {{ dealer.otherProducts }}</p>
              }
              @if (!dealer.driveOver && !dealer.handheld && !dealer.otherProducts) {
                <p class="text-xs text-text-muted dark:text-on-surface-variant">N/A</p>
              }
            </td>
            <td class="p-4">
              <p class="font-body-sm text-text-main dark:text-on-surface">{{ dealer.laneCount || 'N/A' }}</p>
            </td>
            <td class="p-4">
              @if (dealer.csatRating) {
                <span class="inline-flex items-center px-2 py-1 rounded-full font-label-sm border"
                      [style.background-color]="sentimentColor(dealer.csatRating) + '1A'"
                      [style.color]="sentimentColor(dealer.csatRating)"
                      [style.border-color]="sentimentColor(dealer.csatRating) + '33'">
                  <span class="w-1.5 h-1.5 rounded-full mr-1.5" [style.background-color]="sentimentColor(dealer.csatRating)"></span>
                  {{ dealer.csatRating }}
                </span>
              } @else {
                <p class="font-body-sm text-text-muted dark:text-on-surface-variant">N/A</p>
              }
            </td>
            <td class="p-4">
              <span class="inline-flex items-center px-2 py-1 rounded-full font-label-sm border"
                    [style.background-color]="statusColor(dealer.customerStatus) + '1A'"
                    [style.color]="statusColor(dealer.customerStatus)"
                    [style.border-color]="statusColor(dealer.customerStatus) + '33'">
                <span class="w-1.5 h-1.5 rounded-full mr-1.5" [style.background-color]="statusColor(dealer.customerStatus)"></span>
                {{ dealer.customerStatus || 'N/A' }}
              </span>
            </td>
            <td class="p-4">
              <p class="font-body-sm text-text-main dark:text-on-surface">{{ dealer.clientSuccessManager || 'N/A' }}</p>
            </td>
            <td class="p-4">
              @if (dealer.serviceAdvisorFirstName || dealer.serviceAdvisorLastName) {
                <p class="font-body-sm text-text-main dark:text-on-surface">{{ dealer.serviceAdvisorFirstName }} {{ dealer.serviceAdvisorLastName }}</p>
                <p class="text-text-muted dark:text-on-surface-variant text-xs">{{ dealer.serviceAdvisorEmail }}</p>
              } @else {
                <p class="text-xs text-text-muted dark:text-on-surface-variant">N/A</p>
              }
            </td>
            <td class="p-4 text-right">
              <div class="flex items-center justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                <button (click)="dealer.dealerId && openEditModal(dealer)" [disabled]="!dealer.dealerId"
                        class="p-2 text-text-muted dark:text-on-surface-variant hover:text-[#00B9F2] rounded hover:bg-surface-variant dark:hover:bg-surface-container-highest transition-colors disabled:opacity-30"
                        [title]="dealer.dealerId ? 'Edit' : 'Run HubSpot Sync to enable editing'">
                  <span class="material-symbols-outlined text-[20px]">edit</span>
                </button>
                <button (click)="deactivateDealer(dealer)" [disabled]="!dealer.dealerId || !dealer.isActive"
                        class="p-2 text-text-muted dark:text-on-surface-variant hover:text-[#ef4444] rounded hover:bg-surface-variant dark:hover:bg-surface-container-highest transition-colors disabled:opacity-30"
                        [title]="dealer.dealerId ? 'Deactivate' : 'Run HubSpot Sync to enable'">
                  <span class="material-symbols-outlined text-[20px]">block</span>
                </button>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

@if (modalOpen()) {
  <div class="fixed inset-0 bg-black/40 z-[60] flex items-center justify-center p-4" (click)="closeModal()">
    <div class="bg-background dark:bg-surface-container-low rounded-xl shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto overflow-x-hidden" (click)="$event.stopPropagation()">
      <div class="p-lg border-b border-border-subtle dark:border-outline-variant flex items-center justify-between">
        <h2 class="font-headline-sm text-headline-sm text-text-main dark:text-on-surface">
          {{ editingDealer() === null ? 'Add Dealer' : 'Edit Dealer' }}
        </h2>
        <button (click)="closeModal()" class="p-1 rounded-full hover:bg-surface-variant dark:hover:bg-surface-variant text-text-muted dark:text-on-surface-variant">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <form [formGroup]="dealerForm" (ngSubmit)="saveDealer()">
        @if (editingDealer() !== null) {
          <div class="mx-lg mt-lg px-3 py-2 rounded-lg bg-[#00B9F2]/10 border border-[#00B9F2]/30 flex items-center gap-2">
            <span class="material-symbols-outlined text-[18px] text-[#00B9F2]">sync_lock</span>
            @if (isHubspotDealer()) {
              <p class="text-xs text-text-main dark:text-on-surface">Synced from HubSpot - these fields are locked here and update automatically. Service Advisors are managed independently below.</p>
            } @else {
              <p class="text-xs text-text-main dark:text-on-surface">These core details are locked once a dealer exists. Only Service Advisors can be edited here.</p>
            }
          </div>
        }
        <div class="p-lg grid grid-cols-1 md:grid-cols-2 gap-4">
          <label class="flex flex-col gap-1 md:col-span-2">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Dealer Name *</span>
            <input formControlName="dealerName" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
            @if (dealerForm.controls.dealerName.invalid && dealerForm.controls.dealerName.touched) {
              <span class="text-xs text-error">Dealer name is required.</span>
            }
          </label>

          <label class="flex flex-col gap-1 md:col-span-2">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Hubspot Dealer ID</span>
            <input formControlName="hubspotDealerId" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <label class="flex flex-col gap-1 md:col-span-2">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Email</span>
            <input formControlName="email" type="email"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <label class="flex flex-col gap-1 md:col-span-2">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Street Name</span>
            <input formControlName="streetName" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">City</span>
            <input formControlName="city" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">State</span>
            <input formControlName="state" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Zip Code</span>
            <input formControlName="zipCode" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <div></div>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Latitude</span>
            <input formControlName="latitude" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Longitude</span>
            <input formControlName="longitude" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Supervisor Name</span>
            <input formControlName="supervisorName" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Phone Number</span>
            <input formControlName="phNo" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Lane Count</span>
            <input formControlName="laneCount" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">CSAT Rating</span>
            <input formControlName="csatRating" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Customer Status</span>
            <input formControlName="customerStatus" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Traxtion Device</span>
            <input formControlName="traxtionDevice" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] disabled:opacity-50 disabled:cursor-not-allowed">
          </label>

          <div class="flex flex-col gap-2 md:col-span-2">
            <div class="flex items-center justify-between">
              <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Service Advisors <span class="text-xs">(all receive job status emails)</span></span>
              <button type="button" (click)="addAdvisorLine()" class="text-xs text-[#00B9F2] hover:opacity-80 flex items-center gap-1">
                <span class="material-symbols-outlined text-[16px]">add</span> Add Advisor
              </button>
            </div>
            @if (advisorsLoading()) {
              <p class="text-xs text-text-muted dark:text-on-surface-variant">Loading...</p>
            } @else if (serviceAdvisors().length === 0) {
              <p class="text-xs text-text-muted dark:text-on-surface-variant">No service advisors added yet.</p>
            }
            @for (advisor of serviceAdvisors(); track $index) {
              <div class="grid grid-cols-1 sm:grid-cols-[1fr_1fr_1.4fr_1fr_auto] gap-2 items-center bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg p-2">
                <input [value]="advisor.firstName" (input)="updateAdvisorField($index, 'firstName', $any($event.target).value)" placeholder="First name" type="text"
                       class="min-w-0 w-full bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-lg px-2 py-1.5 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
                <input [value]="advisor.lastName" (input)="updateAdvisorField($index, 'lastName', $any($event.target).value)" placeholder="Last name" type="text"
                       class="min-w-0 w-full bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-lg px-2 py-1.5 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
                <input [value]="advisor.email" (input)="updateAdvisorField($index, 'email', $any($event.target).value)" placeholder="Email" type="email"
                       class="min-w-0 w-full bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-lg px-2 py-1.5 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
                <input [value]="advisor.phone" (input)="updateAdvisorField($index, 'phone', $any($event.target).value)" placeholder="Phone" type="text"
                       class="min-w-0 w-full bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-lg px-2 py-1.5 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
                <button type="button" (click)="removeAdvisorLine($index)" class="p-1 text-text-muted hover:text-[#ef4444] justify-self-end">
                  <span class="material-symbols-outlined text-[18px]">close</span>
                </button>
              </div>
            }
          </div>
        </div>

        <div class="p-lg border-t border-border-subtle dark:border-outline-variant flex items-center justify-end gap-3">
          <button type="button" (click)="closeModal()"
                  class="h-[44px] px-6 border border-border-subtle dark:border-outline-variant rounded-lg text-text-main dark:text-on-surface hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors font-label-md">
            Cancel
          </button>
          <button type="submit" [disabled]="saving()"
                  class="h-[44px] px-6 bg-[#00B9F2] text-white rounded-lg hover:opacity-90 transition-opacity font-label-md disabled:opacity-50">
            {{ saving() ? 'Saving...' : (editingDealer() === null ? 'Add Dealer' : 'Save Changes') }}
          </button>
        </div>
      </form>
    </div>
  </div>
}
